import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Eye, EyeOff } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [showPassword, setShowPassword] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  
  console.log(token);
  
  const validationSchema = Yup.object().shape({
    password: Yup.string()
      .min(6, t('login.passwordMin'))
      .required(t('login.passwordRequired')),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('password'), null], t('login.passwordsMustMatch'))
      .required(t('login.confirmPasswordRequired')),
  });

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
  if (!token) {
    toast.error(t('login.resetTokenMissing'));
    setSubmitting(false);
    return;
  }

  try {
    await axios.post(`https://server.dev.dynootech.com/auth/password-reset?token=${token}`, {
      password: values.password,
    });
    toast.success(t('login.passwordResetSuccess'));
    resetForm();
    // Wait 1 second then navigate
      setTimeout(() => {
        navigate('/login'); 
      }, 1000);
  } catch (err) {
    toast.error(err.response?.data?.message || t('login.somethingWentWrong'));
  } finally {
    setSubmitting(false);
  }
};


  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-2xl min-h-[500px] bg-white p-10 rounded-2xl shadow-xl">
        <h2 className="text-2xl font-bold text-center mb-6">🔒 {t('login.resetPassword')}</h2>
        <Formik
          initialValues={{ password: '' }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form className="space-y-6">
              {/* Password */}
              <div>
                <label className="block text-sm font-medium mb-1">
                  {t('login.newPassword')}
                </label>
                <div className="relative">
                  <Field
                    type={showPassword ? 'text' : 'password'}
                    name="password"
                    placeholder={t('login.enterNewPassword')}
                    className="w-full px-4 py-3 border rounded-md focus:ring-2 focus:ring-blue-500 outline-none"
                  />
                  <span
                    className="absolute left-3 top-3 cursor-pointer text-gray-500"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                  </span>
                </div>
                <ErrorMessage name="password" component="div" className="text-sm text-red-500 mt-1" />
              </div>

              {/* Confirm Password */}
              <div>
                <label className="block text-sm font-medium mb-1">
                  {t('login.confirmPassword')}
                </label>
                <div className="relative">
                  <Field
                    type={showPassword ? 'text' : 'password'}
                    name="confirmPassword"
                    placeholder={t('login.confirmNewPassword')}
                    className="w-full px-4 py-3 border rounded-md focus:ring-2 focus:ring-blue-500 outline-none"
                  />
                </div>
                <ErrorMessage name="confirmPassword" component="div" className="text-sm text-red-500 mt-1" />
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full py-2 bg-primary hover:bg-primary/90 text-white font-bold rounded"
              >
                {isSubmitting ? t('login.resetting') : t('login.resetPassword')}
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}
